<template>
  <div id="processforms">
    <div class="container">
      <div class="row-fluid clearfix">
        <div class="w-100">
          <h4>Standards and Processes</h4>
          <button class="btn-sm btn-info floatleft" v-on:click="addStandardForm()">Add Standard</button>
        </div>
        <div class="row-fluid clearfix">
          <div class="col-2 float-left">Standard</div>
          <div class="col-3 float-left">Process</div>
          <div class="col-3 float-left">Parent</div>
          <div class="col-4 float-left" />
        </div>

        <div v-for="qstandard in standards" :key="qstandard.id">
          <div class="row-fluid clearfix">
            <div class="col-2 p-3 float-left">{{qstandard.name}}</div>
            <div class="col-3 p-3 float-left"></div>
            <div class="col-3 p-3 float-left"></div>
            <div class="col-4 p-3 float-left text-left">
              <button class="btn-sm btn-info" v-on:click="getStandard(qstandard.id)">Edit</button>
              <button class="btn-sm btn-danger" v-on:click="deleteStandard(qstandard.id)">Delete</button>
              <button class="btn-sm btn-info" v-on:click="addProcessForm(qstandard.id)">Add Process</button>
              <button class="btn-sm btn-info" v-on:click="editAspectsForm(qstandard.id)">Aspects</button>
            </div>
          </div>

          <div v-for="qprocess in processes" :key="qprocess.id">
            <div class="row-fluid clearfix" v-if="qprocess.standard == qstandard.id">
              <div class="col-2 p-3 float-left">{{qprocess.standard_name}}</div>
              <div class="col-3 p-3 float-left">{{qprocess.name}}</div>
              <div class="col-3 p-3 float-left">{{qprocess.parent_name}}</div>
              <div class="col-4 p-3 float-left text-left">
                <button class="btn-sm btn-info" v-on:click="showProcess(qprocess.id, 'edit')">Edit</button>
                <button
                  class="btn-sm btn-info"
                  v-on:click="showProcess(qprocess.id, 'permissions')"
                >Permissions</button>
                <button class="btn-sm btn-danger" v-on:click="deleteProcess(qprocess.id)">Delete</button>
                <button
                  class="btn-sm btn-info"
                  v-on:click="addProcessForm(qstandard.id, qprocess.id)"
                >Add Sub Process</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="loading" v-if="loading===true">Loading&#8230;</div>

    <!-- Edit Process Modal -->
    <b-modal id="editProcessModal" @ok="updateProcess" ref="modal" title="EDIT PROCESS" size='lg'>
      <form @submit.stop.prevent="updateProcess">
        <div class="modal-body">
          <div v-if="message" class="form-group">
            <div class="alert alert-warning">{{ message }}</div>
          </div>
          <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="reference" id="label_reference">Reference</label>
                    <input
                        type="text"
                        class="form-control"
                        id="reference"
                        autofocus
                        placeholder="Enter Reference"
                        v-model="currentProcess.reference"
                        required="required"
                    />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="name" id="label_name">Name</label>
                    <input
                        type="text"
                        class="form-control"
                        id="name"
                        autofocus
                        placeholder="Enter Name"
                        v-model="currentProcess.name"
                        required="required"
                    />
                </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="description" id="label_description">Description</label>
                  <textarea
                    class="form-control"
                    id="description"
                    placeholder="Enter Process Description"
                    v-model="currentProcess.description"
                  ></textarea>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="process_type" id="label_process_type">Process Type</label>
                <select class="form-control" id="process_type" v-model="currentProcess.process_type" disabled>
                  <option :value="null" disabled selected>Enter Process Type</option>
                  <option value="C">Clave</option>
                  <option value="E">Estratégico</option>
                  <option value="S">De Soporte</option>
                </select>
              </div>
            </div>
          </div>  
          <div class="row">
            <div class="col-6">
              <div class="form-group">
                <label for="entries" id="label_entries">Entries</label>
                <textarea
                  class="form-control"
                  id="entries"
                  placeholder="Enter the entries"
                  v-model="currentProcess.entries"
                ></textarea>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="outputs" id="label_outputs">Outputs</label>
                <textarea
                  class="form-control"
                  id="outputs"
                  placeholder="Enter the outputs"
                  v-model="currentProcess.outputs"
                ></textarea>
              </div>
            </div>
          </div>          
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="activities" id="label_activities">Activities</label>
                <textarea
                  class="form-control"
                  id="activities"
                  placeholder="Enter activities"
                  v-model="currentProcess.activities"
                ></textarea>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="process_object" id="label_process_object">Process Object</label>
                <textarea
                  class="form-control"
                  id="process_object"
                  placeholder="Enter process object"
                  v-model="currentProcess.process_object"
                ></textarea>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label for="scope" id="label_scope">Scope</label>
                <textarea
                  class="form-control"
                  id="scope"
                  placeholder="Enter scope"
                  v-model="currentProcess.scope"
                ></textarea>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label for="process_entries" id="label_process_entries">Process Entries</label>
                <b-form-select
                  id="process_entries"
                  v-model="currentProcess.process_entries"
                  :options="process_entries"
                  multiple
                ></b-form-select>
              </div>
            </div>  
          </div> 
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="responsible_roles">Roles that are responsibles of the Process</label>
                <b-form-select
                    id="responsible_roles"
                    multiple
                    v-model="currentProcess.responsible_roles"
                    :options="allRoles"
                    :required="false"
                ></b-form-select>
              </div>
            </div>
          </div>  
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="creator_roles">Roles that can create BPs implementing the Process</label>
                <b-form-select
                  id="creator_roles"
                  multiple
                  v-model="currentProcess.creator_roles"
                  :options="allRoles"
                  :required="false"
                ></b-form-select>
              </div>
            </div>
          </div>  
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label for="reader_roles">Roles that can read ALL BPs implementing the Process</label>
                <b-form-select
                    id="reader_roles"
                    multiple
                    v-model="currentProcess.reader_roles"
                    :options="allRoles"
                    :required="false"
                ></b-form-select>
              </div>
            </div>
          </div>          
        </div>  
      </form>
    </b-modal>
    <!-- End of edit process modal -->

    <!-- Edit Permissions Modal -->
    <b-modal
      size="lg"
      id="editPermissionsModal"
      @ok="updateProcess"
      ref="permissionsmodal"
      :title="`EDIT PROCESS PERMISSIONS ${this.currentProcess.name}`"
    >
      <form @submit.stop.prevent="updateProcess">
        <div v-if="message" class="form-group">
          <div class="alert alert-warning">{{ message }}</div>
        </div>
        <div class="modal-body">
          <table>
            <tr>
              <th>Permission ID</th>
              <th>Roles Allowed</th>
              <th>Departments Allowed</th>
            </tr>
            <tr v-for="permission in currentProcess.qprocesspermission_set" :key="permission.id">
              <td>
                <input type="hidden" v-model="permission.id" />
                <input
                  type="text"
                  class="form-control"
                  id="permission_id"
                  autofocus
                  placeholder="Enter Permission ID"
                  v-model="permission.permission_id"
                  required="required"
                />
              </td>
              <td>
                <b-form-select
                  id="roles_allowed"
                  multiple
                  v-model="permission.roles_allowed"
                  :options="allRoles"
                  :required="false"
                ></b-form-select>
              </td>
              <td>
                <b-form-select
                  id="departments_allowed"
                  multiple
                  v-model="permission.departments_allowed"
                  :options="allDepartments"
                  :required="false"
                ></b-form-select>
              </td>
              <td>
                <button
                  class="btn-sm btn-danger"
                  v-on:click="deletePermission(permission.id)"
                >Delete</button>
              </td>
            </tr>
            <tr>
              <td>
                <input
                  type="text"
                  class="form-control"
                  id="permission_id"
                  autofocus
                  placeholder="Enter Permission ID"
                  v-model="newPermission.permission_id"
                  required="required"
                />
              </td>
              <td>
                <b-form-select
                  id="roles_allowed"
                  multiple
                  v-model="newPermission.roles_allowed"
                  :options="allRoles"
                  :required="false"
                ></b-form-select>
              </td>
              <td>
                <b-form-select
                  id="departments_allowed"
                  multiple
                  v-model="newPermission.departments_allowed"
                  :options="allDepartments"
                  :required="false"
                ></b-form-select>
              </td>
              <td>
                <button class="btn-sm btn-info" v-on:click="addProcessPermission()">Add</button>
              </td>
            </tr>
          </table>
        </div>
      </form>
    </b-modal>
    <!-- End of edit permissions modal -->

    <!-- Edit Standard Modal -->
    <b-modal id="editStandardModal" @ok="updateStandard" ref="modalstandard" title="EDIT STANDARD">
      <form @submit.stop.prevent="updateStandard">
        <div class="modal-body">
          <div v-if="message" class="form-group">
            <div class="alert alert-warning">{{ message }}</div>
          </div>
          <div class="form-group">
            <label for="name" id="label_name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              autofocus
              placeholder="Enter Name"
              v-model="currentStandard.name"
              required="required"
            />
          </div>
        </div>
      </form>
    </b-modal>
    <!-- End of edit standard modal -->

    <!-- Add Process Modal -->
    <b-modal id="addProcessModal" @ok="addProcess" ref="addmodal" title="ADD PROCESS">
      <form @submit.stop.prevent="addProcess">
        <div class="modal-body">
          <div v-if="message" class="form-group">
            <div class="alert alert-warning">{{ message }}</div>
          </div>
          <div class="form-group">
            <label for="name" id="label_name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              autofocus
              placeholder="Enter Name"
              v-model="newProcess.name"
              required="required"
            />
          </div>
          <div class="form-group">
            <label for="description" id="label_description">Description</label>
            <textarea
              class="form-control"
              id="  description"
              placeholder="Enter Process Description"
              v-model="newProcess.description"
            ></textarea>
          </div>
        </div>
      </form>
    </b-modal>
    <!-- End of new process modal -->

    <!-- Add Standard Modal -->
    <b-modal id="addStandardModal" @ok="addStandard" ref="addmodalstandard" title="ADD STANDARD">
      <form @submit.stop.prevent="addStandard">
        <div class="modal-body">
          <div v-if="message" class="form-group">
            <div class="alert alert-warning">{{ message }}</div>
          </div>
          <div class="form-group">
            <label for="name" id="label_name">Name</label>
            <input
              type="text"
              class="form-control"
              id="name"
              autofocus
              placeholder="Enter Name"
              v-model="newStandard.name"
              required="required"
            />
          </div>
        </div>
      </form>
    </b-modal>
    <!-- End of new standard modal -->

    <!-- Edit Aspects Modal -->
    <b-modal id="editAspectsModal" @ok="addAspect" ref="aspectsmodal" title="DEFINE ASPECTS">
      <form @submit.stop.prevent="addAspect">
        <div class="modal-body">
          <div v-if="message" class="form-group">
            <div class="alert alert-warning">{{ message }}</div>
          </div>
          <div v-for="qaspect in aspects" :key="qaspect.id">
            <div class="form-group clearfix" v-if="qaspect.standard == current_standard_id">
              <div class="col-8 p-3 float-left">
                <input
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Enter Name"
                  v-bind:value="qaspect.name"
                  @change="updateAspect(event, qaspect)"
                  required="required"
                />
              </div>
              <div class="col-2 p-3 float-left">
                <button class="btn btn-danger" v-on:click="deleteAspect(qaspect.id)">Delete</button>
              </div>
            </div>
          </div>
          <div class="form-group col-8 p-3">
            <input
              type="text"
              class="form-control"
              id="name"
              autofocus
              placeholder="Enter Name"
              v-model="newAspect.name"
              required="required"
            />
          </div>
        </div>
      </form>
    </b-modal>
    <!-- End of new standard modal -->

    <div class="loading" v-if="loading===true">Loading&#8230;</div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import Roles from '@/api/Roles'

export default {
  name: 'qprocess_forms',
  cache: false,
  data: function() {
    return {
      loading: false,
      message: null,
      current_standard_id: null,
      standards: [],
      currentStandard: {},
      newStandard: {},
      processes: [],
      currentProcess: {},
      newProcess: {},
      newPermission: {},
      aspects: [],
      newAspect: {},
      current_standard_aspects: [],
      allRoles: [],
      allDepartments: [],
      process_entries: [],
    }
  },
  computed: mapState(['sitePath']),
  mounted: function() {
    this.getStandards()
    this.getProcesses()
    this.getAspects()
    this.getRoles()
    this.getDepartments()
  },
  methods: {
    getRoles() {
      Roles.get(this.sitePath)
        .then(response => {
          this.allRoles = []
          for (var role of response.results) {
            this.allRoles.push({ value: role.id, text: role.name })
          }
        })
        .catch(err => {
          console.log(err)
        })
    },
    getDepartments: function() {
      this.loading = true
      this.$http
        .get(
          this.$base + '/api/v1' + this.$session.get('site') + '/department/',
        )
        .then(response => {
          this.allDepartments = []
          for (var dep of response.data['results']) {
            this.allDepartments.push({ value: dep.id, text: dep.name })
          }
          this.loading = false
        })
        .catch(err => {
          console.log(err)
        })
    },
    getStandards: function() {
      this.loading = true
      this.$http
        .get(this.$base + '/api/v1' + this.$session.get('site') + '/standard/')
        .then(response => {
          this.standards = response.data['results']
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    getProcesses: function() {
      this.loading = true
      this.$http
        .get(this.$base + '/api/v1' + this.$session.get('site') + '/process/')
        .then(response => {
          this.processes = response.data['results']
          if (this.currentProcess) {
            for (var i = 0; i < this.processes.length; i++) {
              var proc = this.processes[i]
              if (this.currentProcess.id == proc.id) this.currentProcess = proc
            }
          }
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    getStandard: function(qstandard_id) {
      this.loading = true
      this.message = ''
      this.$http
        .get(
          this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/standard/' +
            qstandard_id +
            '/',
        )
        .then(response => {
          this.currentStandard = response.data
          this.current_standard_id = this.currentStandard.id
          this.updateStandardAspects()
          this.$refs.modalstandard.show()
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    showProcess: function(qprocess_id, dest) {
      this.loading = true
      this.message = ''
      this.$http
        .get(
          this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/process/' +
            qprocess_id +
            '/',
        )
        .then(response => {
          this.currentProcess = response.data
          this.current_standard_id = this.currentProcess.standard
          this.updateStandardAspects()
          this.loading = false
          if (dest == 'permissions') this.$refs.permissionsmodal.show()
          else this.$refs.modal.show()
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    updateStandard: function(evt) {
      if (evt) evt.preventDefault()

      this.loading = true
      this.message = ''
      this.$http
        .put(
          this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/standard/' +
            this.currentStandard.id +
            '/',
          this.currentStandard,
        )
        .then(() => {
          this.loading = false
          this.getStandards()
          this.$refs.modalstandard.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    updateProcess: function(evt) {
      if (evt) evt.preventDefault()

      this.loading = true
      this.message = ''
      this.$http
        .put(
          this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/process/' +
            this.currentProcess.id +
            '/',
          this.currentProcess,
        )
        .then(() => {
          this.loading = false
          this.getProcesses()
          this.$refs.modal.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    deleteStandard: function(id) {
      if (confirm('Are you sure you want to delete this standard?')) {
        this.loading = true
        this.message = ''
        this.$http
          .delete(
            this.$base +
              '/api/v1' +
              this.$session.get('site') +
              '/standard/' +
              id +
              '/',
          )
          .then(() => {
            this.loading = false
            this.getStandards()
          })
          .catch(err => {
            this.render_form_errors(err)
          })
      }
    },
    deleteProcess: function(id) {
      if (confirm('Are you sure you want to delete this process?')) {
        this.loading = true
        this.message = ''
        this.$http
          .delete(
            this.$base +
              '/api/v1' +
              this.$session.get('site') +
              '/process/' +
              id +
              '/',
          )
          .then(() => {
            this.loading = false
            this.getProcesses()
          })
          .catch(err => {
            this.render_form_errors(err)
          })
      }
    },
    deletePermission: function(id) {
      var pos = -1
      for (
        pos = 0;
        pos < this.currentProcess.qprocesspermission_set.length;
        pos++
      ) {
        if (this.currentProcess.qprocesspermission_set[pos].id == id) break
      }
      if (pos >= 0) this.currentProcess.qprocesspermission_set.splice(pos, 1)
    },
    addStandardForm: function() {
      this.message = ''
      this.newStandard = {}
      this.$refs.addmodalstandard.show()
    },
    addProcessForm: function(standard_id, parent_id) {
      this.message = ''
      this.current_standard_id = standard_id
      this.updateStandardAspects()
      this.newProcess = {}
      this.newProcess.standard = standard_id
      this.newProcess.parent = parent_id
      this.newProcess.responsible_roles = new Array()
      this.newProcess.creator_roles = new Array()
      this.newProcess.reader_roles = new Array()
      this.$refs.addmodal.show()
    },
    addStandard: function(evt) {
      if (evt) evt.preventDefault()

      this.loading = true
      this.message = ''
      this.$http
        .post(
          this.$base + '/api/v1' + this.$session.get('site') + '/standard/',
          this.newStandard,
        )
        .then(() => {
          this.loading = false
          this.getStandards()
          this.$refs.addmodalstandard.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    addProcess: function(evt) {
      if (evt) evt.preventDefault()

      this.loading = true
      this.message = ''
      this.$http
        .post(
          this.$base + '/api/v1' + this.$session.get('site') + '/process/',
          this.newProcess,
        )
        .then(() => {
          this.loading = false
          this.getProcesses()
          this.$refs.addmodal.hide()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    addProcessPermission: function(evt) {
      if (evt) evt.preventDefault()

      if (!this.newPermission.permission_id) {
        this.message = "Permission ID couldn't be empty"
        return
      }
      this.loading = true
      this.message = ''
      this.newPermission.process = this.currentProcess.id
      this.$http
        .post(
          this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/processpermission/',
          this.newPermission,
        )
        .then(() => {
          this.loading = false
          this.getProcesses()
          this.newPermission = {}
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    editAspectsForm: function(standard_id) {
      this.message = ''
      this.newAspect = {}
      this.newAspect.standard = standard_id
      this.current_standard_id = standard_id
      this.updateStandardAspects()
      this.$refs.aspectsmodal.show()
      this.getAspects()
    },
    addAspect: function(evt) {
      if (evt) evt.preventDefault()

      this.loading = true
      this.message = ''
      this.$http
        .post(
          this.$base + '/api/v1' + this.$session.get('site') + '/aspect/',
          this.newAspect,
        )
        .then(() => {
          this.loading = false
          this.getAspects()
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    updateAspect: function(evt, currentAspect) {
      if (evt) evt.preventDefault()

      this.loading = true
      this.message = ''
      this.$http
        .put(
          this.$base +
            '/api/v1' +
            this.$session.get('site') +
            '/aspect/' +
            currentAspect.id +
            '/',
          currentAspect,
        )
        .then(() => {
          this.loading = false
          this.getAspects()
          this.newAspect.name = ''
        })
        .catch(err => {
          this.render_form_errors(err)
        })
    },
    deleteAspect: function(id) {
      if (confirm('Are you sure you want to delete this standard aspect?')) {
        this.loading = true
        this.message = ''
        this.$http
          .delete(
            this.$base +
              '/api/v1' +
              this.$session.get('site') +
              '/aspect/' +
              id +
              '/',
          )
          .then(() => {
            this.loading = false
            this.getAspects()
          })
          .catch(err => {
            this.render_form_errors(err)
          })
      }
    },
    getAspects: function() {
      this.loading = true
      this.$http
        .get(this.$base + '/api/v1' + this.$session.get('site') + '/aspect/')
        .then(response => {
          this.aspects = response.data['results']
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          alert(err)
        })
    },
    updateStandardAspects: function() {
      this.current_standard_aspects = [{ value: null, text: '' }]
      for (var i = 0; i < this.aspects.length; i++) {
        if (this.aspects[i].standard == this.current_standard_id) {
          this.current_standard_aspects[
            this.current_standard_aspects.length
          ] = { value: this.aspects[i].id, text: this.aspects[i].name }
        }
      }
    },
  },
}
</script>
            
 
